import React from 'react'
import {
  Collapse
} from '@material-ui/core'
import { Link } from 'react-router-dom';
import './UnderLinks.scss'


export default function UnderLinks(props) {
  const {
    links,
    open,
    prismicCtx
  } = props



  if (links.length === 0) {
    return null
  } else if (links.length <= 5) {
    return (
      <Collapse in={open} className='underLinks__collapse'>
        <div className='underLinks__wrapper'>
          {links.map((link, i) => (
            <div key={i} style={{ margin: '5px 0' }}>
              <Link
                className='underLinks__link underLinks__link-middle'
                key={link.id}
                to={prismicCtx.linkResolver(link.linkur)}
                style={{ padding: 0 }}
              >
                {link.nafn[0].text}
              </Link>
            </div>
          ))}
        </div>
      </Collapse>
    )
  } else {
    // let tempLinks = []
    // let counter = 1
    // let innerTempLinks = []
    // links.map(link => {
    //   innerTempLinks.push(link)
    //   if (counter % 5 === 0 || counter === links.length) {
    //     tempLinks.push(innerTempLinks)
    //     innerTempLinks = []
    //   }
    //   counter += 1
    // })
    return (
      <Collapse in={open} className='underLinks__collapse' style={{ zIndex: 100 }}>
        {/* <div className='test'>
          {tempLinks.map((col, index) => (
            <div key={index} className='underLinks__wrapper'>
              {col.map(link => (
                <div style={{margin: '7px 0'}}>
                  <Link
                    className='underLinks__link underLinks__link-middle'
                    key={link.id}
                    to={prismicCtx.linkResolver(link.linkur)}>
                    {link.nafn[0].text}
                  </Link>
                </div>
              ))}
            </div>
          ))}
        </div> */}
        <div style={{ display: 'flex', flexWrap: 'wrap', width: 270, paddingTop: 10, paddingBottom: 10, padding: 10 }}>
          {links.map((link, i) => (
            <div key={i} style={{ margin: '5px 0', width: '50%', display: 'flex', justifyContent: '', alignItems: 'center' }}>
              <Link
                className='underLinks__link underLinks__link-middle'
                key={link.id}
                to={prismicCtx.linkResolver(link.linkur)}
                style={{ padding: 0, textAlign: '' }}
              >
                {link.nafn[0].text}
              </Link>
            </div>
          ))}
        </div>
      </Collapse>
    )
  }
} 